import { useEffect, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { connect, useStore } from "react-redux";
import useMedia from "use-media";
import "../../../../src/index.css";
import { GetPublicHoliday } from "../../../hooks/getPublicHoliday";
import { ModalClose } from "../../atoms/RTCC/modalClose";
import './../../../resources/RTCC/css/popup/popup.css';


const CheckCalendarContainer = (props) => {
    const { state, onClickOpenCalendarWindow, checkInFlg, checkOutFlg, inputFlightInfo } = props;

    // 祝日取得用カスタムフック
    const { getHoliday } = GetPublicHoliday();

    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);
    const [selectDate1, setSelectDate] = useState("");
    const [activeStartDate, setActiveStartDate] = useState(null);
    const [activeViewDate, setActiveViewDate] = useState(null);
    const [maxDate, setMaxDate] = useState(null);
    const [minDate, setMinDate] = useState(null);
    let count = 0;
    const popupFlg = state.calendarPopup;
    const store = useStore();

    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);

    // プレー日欄に表示する日付取得(初回レンダリング時)
    useEffect(() => {
        let selectDate = new Date();
        selectDate.setDate(selectDate.getDate() + 15);
        setSelectDate(selectDate);

        // カレンダー表示起点日
        let startDate = new Date();
        //storeにdateが入っていればそちらを使う
        if (checkInFlg) {
            let checkIn = new Date(store.getState().checkIn);
            setSelectDate(checkIn);
            startDate = checkIn;
            // カレンダー選択項目
            setActiveStartDate(checkIn);
            setActiveViewDate(checkIn);
        } else if (checkOutFlg) {
            let checkOut = new Date(store.getState().checkOut);
            setSelectDate(checkOut);
            startDate = checkOut;
            // カレンダー選択項目
            setActiveStartDate(checkOut);
            setActiveViewDate(checkOut);
        } else if (state.goBoardingFlg) {
            let goBoarding = store.getState().inputFlightInfo.goBoardingDate ? store.getState().inputFlightInfo.goBoardingDate : "";
            let goBoardingDate = new Date(goBoarding != "" ? goBoarding : store.getState().checkIn);
            setSelectDate(goBoardingDate);
            startDate = goBoardingDate;
            // カレンダー選択項目
            setActiveStartDate(goBoardingDate);
            setActiveViewDate(goBoardingDate);
        } else if (state.backBoardingFlg) {
            let backBoarding = store.getState().inputFlightInfo.backBoardingDate ? store.getState().inputFlightInfo.backBoardingDate : "";
            let backBoardingDate = new Date(backBoarding != "" ? backBoarding : store.getState().checkOut);
            setSelectDate(backBoardingDate);
            startDate = backBoardingDate;
            // カレンダー選択項目
            setActiveStartDate(backBoardingDate);
            setActiveViewDate(backBoardingDate);
        }
        let now = new Date();
        let d1Month = startDate.getFullYear() * 12 + startDate.getMonth();
        let d2Month = now.getFullYear() * 12 + now.getMonth();
        let diffMonth = d1Month - d2Month;
        count = diffMonth;

        // カレンダー最大選択範囲
        let maxDate = new Date();
        maxDate.setDate(maxDate.getDate() + 350);
        setMaxDate(maxDate);

        // カレンダー最小選択範囲
        let minDate = new Date();
        if (checkInFlg || checkOutFlg) {
            minDate.setDate(checkInFlg ? (minDate.getDate() + 15) : (minDate.getDate() + 16));
        }
        setMinDate(minDate);

        // 次へ表示ボタンに関数登録
        const nextElm = document.getElementsByClassName("react-calendar__navigation__arrow react-calendar__navigation__next-button");
        nextElm[0].addEventListener("click", nextDate);

        // 戻る表示ボタンに関数登録
        const prevElm = document.getElementsByClassName("react-calendar__navigation__arrow react-calendar__navigation__prev-button");
        prevElm[0].addEventListener("click", prevDate);
    }, [popupFlg]);

    // 次へ表示制御
    const nextDate = () => {
        let date = new Date();
        date.setDate(1);
        count += 1;
        date.setMonth(date.getMonth() + count);
        setActiveStartDate(date);
    }

    // 戻る表示制御
    const prevDate = () => {
        let date = new Date();
        count -= 1;
        if (count < 0) {
            count = 0;
            return;
        }
        date.setMonth(date.getMonth() + count);
        setActiveStartDate(date);
    }


    // 表示する日付取得
    const getDateToString = (val, event) => {
        if (checkInFlg) {
            store.dispatch({ type: "CHECKIN", payload: { checkIn: val } });
            let checkOut = new Date(store.getState().checkOut);
            checkOut.setHours(0);
            checkOut.setMinutes(0);
            checkOut.setSeconds(0);
            checkOut.setMilliseconds(0);
            if (checkOut <= val) {
                checkOut.setDate(1);
                checkOut.setFullYear(val.getFullYear());
                checkOut.setMonth(val.getMonth());
                checkOut.setDate(val.getDate() + 1);
                store.dispatch({ type: "CHECKOUT", payload: { checkOut: checkOut } });
            }
        } else if (checkOutFlg) {
            store.dispatch({ type: "CHECKOUT", payload: { checkOut: val } });
            let checkIn = new Date(store.getState().checkIn);
            checkIn.setHours(0);
            checkIn.setMinutes(0);
            checkIn.setSeconds(0);
            checkIn.setMilliseconds(0);
            if (checkIn >= val) {
                checkIn.setFullYear(val.getFullYear());
                checkIn.setMonth(val.getMonth());
                checkIn.setDate(val.getDate() - 1);
                store.dispatch({ type: "CHECKIN", payload: { checkIn: checkIn } });
            }
        } else if (state.goBoardingFlg) {
            let bordingDate = new Date(store.getState().inputFlightInfo.backBoardingDate);
            if (bordingDate <= val) {
                bordingDate.setDate(1);
                bordingDate.setFullYear(val.getFullYear());
                bordingDate.setMonth(val.getMonth());
                bordingDate.setDate(val.getDate() + 1);
            }
            store.dispatch({ type: "INPUT_FLIGHT_INFO", payload: { inputFlightInfo: { ...inputFlightInfo, goBoardingDate: val, backBoardingDate: bordingDate } } });
        } else if (state.backBoardingFlg) {
            let bordingDate = new Date(store.getState().inputFlightInfo.goBoardingDate);
            if (bordingDate >= val) {
                bordingDate.setFullYear(val.getFullYear());
                bordingDate.setMonth(val.getMonth());
                bordingDate.setDate(val.getDate() - 1);
            }
            store.dispatch({ type: "INPUT_FLIGHT_INFO", payload: { inputFlightInfo: { ...inputFlightInfo, goBoardingDate: bordingDate, backBoardingDate: val } } });
        }
        // ポップアップの表示・非表示用更新関数
        onClickOpenCalendarWindow();
    };

    // カレンダーの月表示を大きくするための関数
    const layoutChangeOfMonth = (date) => {

        const from = document.getElementsByClassName("react-calendar__navigation__label__labelText--from")[0];
        const to = document.getElementsByClassName("react-calendar__navigation__label__labelText--to")[0];
        const y = date.getFullYear();
        const m = date.getMonth() + 1;

        if (from && to) {

            if (!from.getAttribute("data-flg")) {
                from.innerHTML = `${y}年<spna class='month-view'> ${m}月</span>`;
                from.setAttribute("data-flg", "on");
            } else {
                to.innerHTML = `${y}年<spna class='month-view'> ${m}月</span>`;
                from.removeAttribute("data-flg");
            }
        }
    };

    // カレンダーの月表示を大きくするための関数(スマホ版)
    const layoutChangeOfMonthMobile = (date) => {

        const label = document.getElementsByClassName("react-calendar__navigation__label__labelText--from")[0];
        const y = date.getFullYear();
        const m = date.getMonth() + 1;

        if (label) {
            label.innerHTML = `${y}年<spna class='month-view'> ${m}月</span>`;
        }
    };

    const onClickClose = () => {
        // ポップアップの表示・非表示用更新関数
        onClickOpenCalendarWindow();
    }

    return (
        <div className={popupFlg ? "popupIsShow" : "popup"} id="js-popup">
            <div className="rtcc_Calendar">
                <ModalClose divStyle={"modalClose"} svgStyle={"modalSvg"} onClick={onClickClose} />
                <h4 className="popupInnerText" >{state.popupTitle}</h4>
                {isMobilePhone ?
                    (<Calendar
                        activeStartDate={activeStartDate}
                        locale={"ja-JP"}
                        calendarType={"US"}
                        maxDate={maxDate}
                        minDate={minDate}
                        value={activeViewDate}
                        showDoubleView={false}
                        onClickDay={(val, event) => getDateToString(val, event)}
                        formatDay={(locale, date) => date.getDate()}
                        tileClassName={({ activeStartDate, date, view }) => getHoliday(activeStartDate, date, view)}
                        formatMonthYear={(locale, date) => layoutChangeOfMonthMobile(date)}
                        nextLabel={""}
                        prevLabel={""}
                        next2Label={null}
                        prev2Label={null} />
                    ) :
                    (<Calendar
                        activeStartDate={activeStartDate}
                        locale={"ja-JP"}
                        calendarType={"US"}
                        maxDate={maxDate}
                        minDate={minDate}
                        value={activeViewDate}
                        showDoubleView={true}
                        onClickDay={(val, event) => getDateToString(val, event)}
                        formatDay={(locale, date) => date.getDate()}
                        tileClassName={({ activeStartDate, date, view }) => getHoliday(activeStartDate, date, view)}
                        formatMonthYear={(locale, date) => layoutChangeOfMonth(date)}
                        nextLabel={""}
                        prevLabel={""}
                        next2Label={null}
                        prev2Label={null} />
                    )}
            </div>
            <div className="blackBackground" id="js-black-bg"></div>
        </div >
    );
};

const mapStateToProps = (state) => {
    return {
        inputFlightInfo: state.inputFlightInfo,
    };
};

export default connect(mapStateToProps, null)(CheckCalendarContainer);

const style = {
    popup: {
        position: "fixed",
        left: "0",
        top: "0",
        width: "100%",
        height: "100%",
        zIndex: "9999",
        opacity: "0",
        visibility: "hidden",
        transition: ".6s",
    },
    popupIsShow: {
        position: "fixed",
        left: "0",
        top: "0",
        width: "100%",
        height: "100%",
        zIndex: "9999",
        opacity: "1",
        visibility: "visible",
        transition: ".6s",
    },
    popupInner: {
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        width: "65%",
        backgroundColor: "#fff",
        zIndex: "2",
    },
    popupInnerMobile: {
        position: "absolute",
        left: "50%",
        bottom: "0%",
        transform: "translate(-50%, 0%)",
        width: "100%",
        backgroundColor: "#fff",
        zIndex: "2",
    },
    popupInnerTextSp: {
        width: "100%",
        textAlign: "center",
        borderBottom: "1px solid #eee",
        margin: 0,
        padding: "20px 0px 20px 0px"
    },
    popupInnerText: {
        width: "100%",
        textAlign: "center",
    },
    closeBtn: {
        position: "absolute",
        right: "10px",
        top: "0px",
        width: "50px",
        height: "50px",
        lineHeight: "50px",
        textAlign: "center",
        cursor: "pointer",
        fontSize: "50px",
        color: "#A5A5A5",
    },
    svg: {
        height: "20",
        width: "20",
    },
    blackBackground: {
        position: "absolute",
        left: "0",
        top: "0",
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, .8)",
        zIndex: "1",
    },
    buttonArea: {
        width: "100%",
        textAlign: "center",
        borderTop: "solid 1px #dddddd",
        padding: "15px 0 40px 0",
    },
    buttonAreaMobile: {
        width: "100%",
        textAlign: "center",
        borderTop: "solid 1px #dddddd",
        padding: "15px 0 15px 0",
    },
    button: {
        color: "#fff",
        backgroundColor: "#000",
        border: "solid 1px #000",
        padding: "15px 120px 15px 120px",
        cursor: "pointer",
    }
}